(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1350],{

/***/ 45971:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit",
      function () {
        return __webpack_require__(18215);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fc14f8a-0"
})(_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "1px" : _height, _color = param.color, color = _color === void 0 ? "#efefef" : _color, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _margin = param.margin, margin = _margin === void 0 ? "0" : _margin;
    return "\n    display: ".concat(isVisible ? "block" : "none", ";\n    height: ").concat(height, ";\n    background-color: ").concat(color, ";\n    margin: ").concat(margin, ";\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var ArrowsButtonDownMin = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray400 */ .Z.color.gray400 : _color, _size = param.size, size = _size === void 0 ? 16 : _size, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonDownMin);


/***/ }),

/***/ 23773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ValidationCheck = function(param) {
    var _size = param.size, size = _size === void 0 ? 22 : _size, _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6177 4.08603C17.308 4.10941 17.0333 4.23068 16.8203 4.43801C16.7884 4.46904 16.6991 4.57074 16.6217 4.66402C16.5444 4.7573 14.562 7.15634 12.2165 9.99522C9.87092 12.8341 7.94719 15.1617 7.94154 15.1677C7.93199 15.1779 7.83829 15.0591 6.61926 13.4912C5.89766 12.5631 5.28336 11.7758 5.25414 11.7416C5.04815 11.5005 4.76686 11.3561 4.42726 11.3171C4.03981 11.2727 3.67174 11.4012 3.385 11.681C3.26909 11.7941 3.18925 11.9037 3.1252 12.0379C3.03536 12.226 2.99499 12.428 3.002 12.6544C3.01031 12.9231 3.08506 13.1368 3.24943 13.3616C3.29208 13.42 6.06564 16.9865 6.13862 17.0768C6.20396 17.1577 6.35713 17.3121 6.4381 17.3787C7.01938 17.8566 7.7708 18.0264 8.49981 17.8445C8.94568 17.7333 9.36276 17.4771 9.67163 17.1248C9.72674 17.062 18.6401 6.27711 18.7207 6.17582C18.859 6.00194 18.9475 5.80736 18.9848 5.59522C19.0002 5.50737 19.0033 5.32047 18.9909 5.21907C18.9532 4.91081 18.8316 4.66495 18.612 4.4526C18.337 4.18674 17.988 4.05808 17.6177 4.08603Z",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationCheck);


/***/ }),

/***/ 57971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ArrowsButtonRightMin = function(param) {
    var _color = param.color, color = _color === void 0 ? "#8D9297" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.2998 11.625L8.72168 8.28125L5.2998 4.95312L6.2373 4L10.6436 8.28125L6.2373 12.5781L5.2998 11.625Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonRightMin);


/***/ }),

/***/ 46799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/opacity.ts + 1 modules
var opacity = __webpack_require__(52172);
;// CONCATENATED MODULE: ./src/components/atom/skeleton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    background-position-x: -20%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 5px;\n  ",
        "\n  background-size: 200% 100%;\n  background-position-x: 180%;\n  animation: 1.6s ",
        " ease-in-out infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var StyledSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4c00a2-0"
})(_templateObject1(), function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.gray40 */.Z.color.gray40 : _backgroundColor, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? "#ffffff" : _gradientColor;
    return "\n    background-color: ".concat(backgroundColor, ";\n    background: linear-gradient(\n        120deg,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 40%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "50%"), " 50%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 60%\n      )\n      ").concat(backgroundColor, ";\n  ");
}, loading);

;// CONCATENATED MODULE: ./src/components/atom/skeleton/index.tsx



var Skeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkeleton, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var skeleton = (Skeleton);


/***/ }),

/***/ 16718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spinner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/spinner/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dashoffset: -124px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  vertical-align: middle;\n  transform-origin: center;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke: ",
        ";\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ",
        " calc(2s * 0.75) ease-in-out infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Stretch = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var SpinnerContainer = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-87510cb7-0"
})(_templateObject2(), function(param) {
    var _size = param.size, size = _size === void 0 ? 28 : _size;
    return {
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
    };
}, Rotate);
var SpinnerCircle = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-87510cb7-1"
})(_templateObject3(), function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return color;
}, Stretch);

;// CONCATENATED MODULE: ./src/components/atom/spinner/index.tsx
/* Ref. https://github.com/GriffinJohnston/uiball-loaders/blob/main/src/components/Ring.js */ 

var Spinner = function(param) {
    var color = param.color, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerContainer, {
        viewBox: "25 25 50 50",
        strokeWidth: "5",
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerCircle, {
            cx: "50",
            cy: "50",
            r: "20",
            color: color
        })
    });
};
/* harmony default export */ var spinner = (Spinner);


/***/ }),

/***/ 8366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/spinner/index.tsx + 1 modules
var spinner = __webpack_require__(16718);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/molecules/loader/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59f274fe-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/molecules/loader/index.tsx



var Loader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
            size: props.size,
            color: props.color
        })
    });
};
/* harmony default export */ var loader = (Loader);


/***/ }),

/***/ 13805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DOCTOR_NOW_COMPANY_LATITUDE; },
/* harmony export */   "y": function() { return /* binding */ DOCTOR_NOW_COMPANY_LONGITUDE; }
/* harmony export */ });
var DOCTOR_NOW_COMPANY_LATITUDE = 37.4995535963247;
var DOCTOR_NOW_COMPANY_LONGITUDE = 127.025752388871;


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 63507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* reexport */ libs/* EWebTreatmentRequestLog */.o5; },
  "hK": function() { return /* reexport */ TreatmentMedicineOpenDateModel; },
  "Js": function() { return /* reexport */ libs/* TreatmentRequestLog */.Js; },
  "cV": function() { return /* reexport */ libs/* filteredF2FDaySchedules */.cV; },
  "QB": function() { return /* reexport */ hooks_useDiagnosesByUserV2; },
  "TI": function() { return /* reexport */ hooks_useGetDoctorTreatmentMedicineOpenDate; }
});

// UNUSED EXPORTS: logs

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/diagnosis.gql.impl.tsx


var GetDoctorTreatmentMedicineOpenDateDocument = "\n    query GetDoctorTreatmentMedicineOpenDate($doctorId: ID!, $treatmentMedicineId: ID!) {\n  getDoctorTreatmentMedicineOpenDate(\n    doctorId: $doctorId\n    treatmentMedicineId: $treatmentMedicineId\n  ) {\n    date\n  }\n}\n    ";
var useGetDoctorTreatmentMedicineOpenDateQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "GetDoctorTreatmentMedicineOpenDate",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(GetDoctorTreatmentMedicineOpenDateDocument, "GetDoctorTreatmentMedicineOpenDate", variables), options);
};
useGetDoctorTreatmentMedicineOpenDateQuery.getKey = function(variables) {
    return [
        "GetDoctorTreatmentMedicineOpenDate",
        variables
    ];
};
useGetDoctorTreatmentMedicineOpenDateQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(GetDoctorTreatmentMedicineOpenDateDocument, "GetDoctorTreatmentMedicineOpenDate", variables, options);
};
var DiagnosesByUserV2Document = "\n    query DiagnosesByUserV2($paginationCriteria: PaginationCriteriaInput!) {\n  diagnosesByUserV2(paginationCriteria: $paginationCriteria) {\n    diagnosis {\n      diagnosisForm {\n        id\n        symptom\n      }\n    }\n  }\n}\n    ";
var useDiagnosesByUserV2Query = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "DiagnosesByUserV2",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(DiagnosesByUserV2Document, "DiagnosesByUserV2", variables), options);
};
useDiagnosesByUserV2Query.getKey = function(variables) {
    return [
        "DiagnosesByUserV2",
        variables
    ];
};
useDiagnosesByUserV2Query.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(DiagnosesByUserV2Document, "DiagnosesByUserV2", variables, options);
};

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/useDiagnosesByUserV2.ts


var parseDiagnosesByUserV2 = function(data) {
    return data.diagnosesByUserV2.map(function(diagnosis) {
        return {
            id: diagnosis.diagnosis.diagnosisForm.id,
            symptom: diagnosis.diagnosis.diagnosisForm.symptom ? diagnosis.diagnosis.diagnosisForm.symptom.slice(0, 150) : ""
        };
    });
};
var useDiagnosesByUserV2 = function(param) {
    var _size = param.size, size = _size === void 0 ? 5 : _size;
    var ref = useDiagnosesByUserV2Query({
        paginationCriteria: {
            size: size,
            sort: gql_schema/* SortType.Desc */.ERp.Desc
        }
    }, {
        select: parseDiagnosesByUserV2
    }), tmp = ref.data, recentlyDetailSymptoms = tmp === void 0 ? [] : tmp, isRecentlyDetailSymptomsLoading = ref.isLoading;
    return {
        recentlyDetailSymptoms: recentlyDetailSymptoms,
        recentlyDetailSymptomsCount: recentlyDetailSymptoms.length,
        isRecentlyDetailSymptomsLoading: isRecentlyDetailSymptomsLoading
    };
};
/* harmony default export */ var hooks_useDiagnosesByUserV2 = (useDiagnosesByUserV2);

;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/useGetDoctorTreatmentMedicineOpenDate.ts


var parseTreatmentMedicineOpenDate = function(data) {
    var ref, ref1;
    if (!(data === null || data === void 0 ? void 0 : (ref = data.getDoctorTreatmentMedicineOpenDate) === null || ref === void 0 ? void 0 : ref.date)) {
        return null;
    }
    return new TreatmentMedicineOpenDateModel({
        openDate: data === null || data === void 0 ? void 0 : (ref1 = data.getDoctorTreatmentMedicineOpenDate) === null || ref1 === void 0 ? void 0 : ref1.date
    });
};
var useGetDoctorTreatmentMedicineOpenDate = function(props) {
    var _treatmentMedicineId;
    var ref = useGetDoctorTreatmentMedicineOpenDateQuery({
        doctorId: props.doctorId,
        treatmentMedicineId: (_treatmentMedicineId = props.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
    }, {
        select: parseTreatmentMedicineOpenDate,
        enabled: props.enabled
    }), openDate = ref.data, isOpenDateFetched = ref.isFetched;
    return {
        openDate: openDate,
        isOpenDateFetched: isOpenDateFetched
    };
};
/* harmony default export */ var hooks_useGetDoctorTreatmentMedicineOpenDate = (useGetDoctorTreatmentMedicineOpenDate);

;// CONCATENATED MODULE: ./src/entities/diagnosis/hooks/index.ts




// EXTERNAL MODULE: ./src/entities/diagnosis/libs/index.ts + 1 modules
var libs = __webpack_require__(54674);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
;// CONCATENATED MODULE: ./src/entities/diagnosis/model/TreatmentMedicineOpenDate.ts

var TreatmentMedicineOpenDateModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentMedicineOpenDateModel(props) {
        (0,_class_call_check/* default */.Z)(this, TreatmentMedicineOpenDateModel);
        this.props = props;
        this.openDate = props.openDate;
    }
    var _proto = TreatmentMedicineOpenDateModel.prototype;
    _proto.getOpenDate = function getOpenDate() {
        return this.openDate;
    };
    return TreatmentMedicineOpenDateModel;
}();

;// CONCATENATED MODULE: ./src/entities/diagnosis/index.ts






/***/ }),

/***/ 36444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": function() { return /* binding */ EWebDiagnosisInflowType; },
/* harmony export */   "Js": function() { return /* binding */ TreatmentRequestLog; },
/* harmony export */   "o5": function() { return /* binding */ EWebTreatmentRequestLog; }
/* harmony export */ });
/* unused harmony export logs */
var TreatmentRequestLog;
(function(TreatmentRequestLog) {
    TreatmentRequestLog["RequestPageIn"] = "request_page_in";
    TreatmentRequestLog["RequestPageInWithTargetDate"] = "request_page_in_with_target_date";
    TreatmentRequestLog["RequestPageInWithoutTargetDate"] = "request_page_in_without_target_date";
    TreatmentRequestLog["RequestClickBookingTime"] = "request_click_booking_time";
    TreatmentRequestLog["RequestSuccessSsn"] = "request_success_ssn";
    TreatmentRequestLog["RequestMoveToPaymentStep"] = "request_move_to_payment_step";
    TreatmentRequestLog["RequestClickNonBenefitCategory"] = "request_click_non_benefit_category";
    TreatmentRequestLog["RequestOpenNonBenefitCategory"] = "request_open_non_benefit_category";
    TreatmentRequestLog["RequestUploadImage"] = "request_upload_image";
    TreatmentRequestLog["RequestPrevStepFromDiagnosis"] = "request_prev_step_from_diagnosis";
    TreatmentRequestLog["RequestPrevStepFromPayment"] = "request_prev_step_from_payment";
    TreatmentRequestLog["RequestClickContinueInModal"] = "request_click_continue_in_modal";
    TreatmentRequestLog["RequestClickStopInModal"] = "request_click_stop_in_modal";
    TreatmentRequestLog["RequestClickAutoAgreementCheck"] = "request_click_auto_agreement_check";
    TreatmentRequestLog["RequestSubmitClick"] = "request_submit_click";
    TreatmentRequestLog["RequestManualOpenCategory"] = "request_manual_open_category";
    TreatmentRequestLog["RequestAutoOpenCategory"] = "request_auto_open_category";
    TreatmentRequestLog["RequestSelectCategory"] = "request_select_category";
    TreatmentRequestLog["RequestPageInQuickMatch"] = "request_page_in_quick_match";
    TreatmentRequestLog["RequestOpenLoadDetailSymptoms"] = "request_open_load_detail_symptoms";
    TreatmentRequestLog["RequestSelectLoadDetailSymptom"] = "request_select_load_detail_symptom";
    TreatmentRequestLog["ImpressedChildInfoSection"] = "impressed_child_info_section";
})(TreatmentRequestLog || (TreatmentRequestLog = {}));
var EWebTreatmentRequestLog;
(function(EWebTreatmentRequestLog) {
    EWebTreatmentRequestLog["CategorySelectItemClick"] = "category_select_item_click";
    EWebTreatmentRequestLog["RequestStepChangeToDiagnosis"] = "web_request_step_change_to_diagnosis";
    EWebTreatmentRequestLog["RequestStepChangeToDoctor"] = "web_request_step_change_to_doctor";
    EWebTreatmentRequestLog["RequestStepChangeToPayment"] = "web_request_step_change_to_payment";
    EWebTreatmentRequestLog["RequestStepChangeToCertificationGuide"] = "web_request_step_change_to_certification_guide";
    EWebTreatmentRequestLog["ClickNextFromDiagnosisStep"] = "click_next_from_diagnosis_step";
    EWebTreatmentRequestLog["ClickCompleteButton"] = "click_complete_button";
    EWebTreatmentRequestLog["ClickTelemedicineRequestInDoctorDetail"] = "click_telemedicine_request_in_doctor_detail";
    EWebTreatmentRequestLog["OpenDoctorDetail"] = "open_doctor_detail";
    EWebTreatmentRequestLog["CloseDoctorDetail"] = "close_doctor_detail";
    EWebTreatmentRequestLog["ClickSelectCardCompany"] = "click_select_card_company";
    EWebTreatmentRequestLog["ClickSelectCard"] = "click_select_card";
    EWebTreatmentRequestLog["ClickAddCreditCard"] = "click_add_credit_card";
    EWebTreatmentRequestLog["ClickAddKakaoPay"] = "click_add_kakao_pay";
    EWebTreatmentRequestLog["ClickOpenInstallment"] = "click_open_installment";
    EWebTreatmentRequestLog["ClickTogglePoint"] = "click_toggle_point";
    EWebTreatmentRequestLog["ClickAgreement"] = "click_agreement";
    EWebTreatmentRequestLog["ClickAllAgreement"] = "click_all_agreement";
    EWebTreatmentRequestLog["ClickAgreementLink"] = "click_agreement_link";
    EWebTreatmentRequestLog["ClickSubmitDiagnosis"] = "click_submit_diagnosis";
    EWebTreatmentRequestLog["ClickCtaButton"] = "click_cta_button";
    EWebTreatmentRequestLog["ClickIdvSheet"] = "click_idv_sheet";
    EWebTreatmentRequestLog["ClickCloseButton"] = "click_close_button";
    EWebTreatmentRequestLog["ClickDoctorPro"] = "click_doctor_pro";
    EWebTreatmentRequestLog["ClickDoctorSort"] = "click_doctor_sort";
    EWebTreatmentRequestLog["ClickReqDoctorSelect"] = "click_req_doctor_select";
    EWebTreatmentRequestLog["ClickRequestTime"] = "click_request_time";
    EWebTreatmentRequestLog["ClickRequestTypeOpen"] = "click_request_type_open";
    EWebTreatmentRequestLog["ClickIdvSheetClose"] = "click_idv_sheet_close";
    EWebTreatmentRequestLog["ClickWebDiagnosisToRequest"] = "click_web_diagnosis_to_request";
    EWebTreatmentRequestLog["ClickWebDiagnosisToCategories"] = "click_web_diagnosis_to_categories";
    EWebTreatmentRequestLog["ClickQuickScheduleMode"] = "click_quick_schedule_mode";
    EWebTreatmentRequestLog["ClickGeneralScheduleMode"] = "click_general_schedule_mode";
    EWebTreatmentRequestLog["ClickDoctorFilterOption"] = "click_doctor_filter_option";
    EWebTreatmentRequestLog["ClickNextFromDoctorFilter"] = "click_next_from_doctor_filter";
    EWebTreatmentRequestLog["ClickLoadMoreDoctorsButton"] = "click_load_more_doctors_button";
})(EWebTreatmentRequestLog || (EWebTreatmentRequestLog = {}));
var logs = {
    request_page_in: "진료신청서 진료신청 페이지 진입",
    request_page_in_with_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 선택)",
    request_page_in_without_target_date: "진료신청서 진료신청 페이지 진입(예약 날짜 미선택)",
    request_click_auto_agreement_check: "진료신청서 자동 동의 체크 클릭",
    request_click_booking_time: "진료신청서 예약 시간 클릭",
    request_click_continue_in_modal: "진료신청서 이탈 모달 내 계속 작성 클릭",
    request_click_stop_in_modal: "진료신청서 이탈 모달 내 그만두기 클릭",
    request_click_non_benefit_category: "진료신청서 내 비급여 카테고리 클릭",
    request_open_non_benefit_category: "진료신청서 내 비급여 카테고리 오픈",
    request_submit_click: "진료신청서 진료 신청",
    request_move_to_payment_step: "진료신청서 결제 단계로 이동",
    request_prev_step_from_diagnosis: "진료신청서 진료신청 단계에서 이전으로 이동",
    request_prev_step_from_payment: "진료신청서 결제 단계에서 이전으로 이동",
    request_success_ssn: "진료신청서 주민번호 입력 완료",
    request_upload_image: "진료신청서 사진 업로드",
    request_manual_open_category: "진료신청서 카테고리 바텀시트 클릭",
    request_auto_open_category: "진료신청서 카테고리 바텀시트 자동 오픈",
    request_select_category: "진료신청서 카테고리 선택",
    request_page_in_quick_match: "진료신청서 퀵매치 진료신청 페이지 진입",
    request_open_load_detail_symptoms: "진료신청서 증상 불러오기 바텀시트 오픈",
    request_select_load_detail_symptom: "진료신청서 증상 불러오기 상세증상 선택",
    impressed_child_info_section: "진료신청서 아이 정보 섹션 노출"
};
var EWebDiagnosisInflowType;
(function(EWebDiagnosisInflowType) {
    EWebDiagnosisInflowType["QnaDetail"] = "qna_detail";
    EWebDiagnosisInflowType["MagazineDetail"] = "magazine_detail";
    EWebDiagnosisInflowType["FaqDetail"] = "faq_detail";
    EWebDiagnosisInflowType["HospitalDetail"] = "hospital_detail";
    EWebDiagnosisInflowType["MedicineDictionaryDetail"] = "medicine_dictionary_detail";
    EWebDiagnosisInflowType["NonBenefitMap"] = "non_benefit_map";
    EWebDiagnosisInflowType["NonBenefitHome"] = "non_benefit_home";
    EWebDiagnosisInflowType["DiseaseEncyclopediaDetail"] = "disease_encyclopedia_detail";
    EWebDiagnosisInflowType["MainHomeFooter"] = "main_home_footer";
})(EWebDiagnosisInflowType || (EWebDiagnosisInflowType = {}));


/***/ }),

/***/ 54674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": function() { return /* reexport */ constants/* EWebTreatmentRequestLog */.o5; },
  "Js": function() { return /* reexport */ constants/* TreatmentRequestLog */.Js; },
  "cV": function() { return /* reexport */ filteredF2FDaySchedules; }
});

// UNUSED EXPORTS: logs

// EXTERNAL MODULE: ./src/entities/diagnosis/libs/constants.ts
var constants = __webpack_require__(36444);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrAfter.js
var isSameOrAfter = __webpack_require__(79212);
var isSameOrAfter_default = /*#__PURE__*/__webpack_require__.n(isSameOrAfter);
;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/f2fDaySchedule.ts



dayjs_min_default().extend((isSameOrAfter_default()));
var filteredF2FDaySchedules = function(days, dateToSelect) {
    if (!dateToSelect) return days;
    var base = dayjs_min_default()(dateToSelect);
    var filtered = days.filter(function(d) {
        return dayjs_min_default()(d.targetDate).isSameOrAfter(base, "day");
    });
    return (0,_to_consumable_array/* default */.Z)(filtered);
};

;// CONCATENATED MODULE: ./src/entities/diagnosis/libs/index.ts





/***/ }),

/***/ 40573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15951);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9912);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79212);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53476);






dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default()));
var useAppInstallTopBanner = function() {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_5__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .appInstallTopBannerState */ .Ep).isVisible;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    // 스크롤 기반 가시성 상태
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isScrollVisible = ref[0], setIsScrollVisible = ref[1];
    var lastScrollYRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(0);
    var rafIdRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    // 스크롤 이벤트 핸들러 (RAF 최적화)
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var threshold = 700;
        var handleScroll = function() {
            // RAF가 이미 예약되어 있으면 중복 실행 방지
            if (rafIdRef.current !== null) {
                return;
            }
            rafIdRef.current = requestAnimationFrame(function() {
                var currentScrollY = window.scrollY;
                var lastScrollY = lastScrollYRef.current;
                // threshold 이하에서는 항상 표시
                if (currentScrollY < threshold) {
                    setIsScrollVisible(true);
                } else {
                    // 위로 스크롤: 표시, 아래로 스크롤: 숨김
                    if (currentScrollY < lastScrollY) {
                        setIsScrollVisible(true);
                    } else if (currentScrollY > lastScrollY) {
                        setIsScrollVisible(false);
                    }
                }
                lastScrollYRef.current = currentScrollY;
                rafIdRef.current = null;
            });
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, []);
    var isNewAdVisibleClient = function(client) {
        var visibleClientTypes = [
            _types_app__WEBPACK_IMPORTED_MODULE_1__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB
        ];
        return visibleClientTypes.includes(client.clientType);
    };
    return {
        isVisible: isVisible,
        isNewAdVisibleClient: isNewAdVisibleClient,
        isScrollVisible: isScrollVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 18215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83651);
/* harmony import */ var _hooks_cuj_useAppInstallTopBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40573);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4611);
/* harmony import */ var _views_non_benefit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13650);
/* harmony import */ var _views_non_benefit_ui_NonBenefitHomeView__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72991);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
// PageDescription: 지역별 비급여 가격비교 페이지










var NonBenefitHomePages = function(param) {
    var client = param.client;
    var ref;
    var viewModel = (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_7__/* .useNonBenefitHomeViewModel */ .Ef)(client);
    var topBannerViewModel = (0,_hooks_cuj_useAppInstallTopBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var treatmentId = viewModel.queries.treatmentId;
    var title = "".concat(viewModel.selectedAddressTitle, " ").concat((ref = viewModel.selectedMedicine) === null || ref === void 0 ? void 0 : ref.medicineDescription, " 처방 최저가 병원/약국 가격(").concat(new Date().getFullYear(), ") - 닥터나우");
    var description = (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_7__/* .getDescriptionForMetaTag */ .cK)(treatmentId);
    var canonical = "".concat("https://doctornow.co.kr").concat(router.asPath);
    var nonBenefitLdJson = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_utils_format__WEBPACK_IMPORTED_MODULE_6__/* .nonBenefitSeoLdJson */ .r3)({
            doctors: viewModel.nonBenefitDoctors,
            address: viewModel.selectedAddressTitle,
            faqs: viewModel.faqs,
            canonical: canonical
        });
    }, [
        viewModel.nonBenefitDoctors,
        viewModel.selectedAddressTitle,
        viewModel.faqs,
        canonical
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                additionalMetaTags: (0,_views_non_benefit__WEBPACK_IMPORTED_MODULE_7__/* .getAdditionalMetaTags */ ._2)(treatmentId)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(nonBenefitLdJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_non_benefit_ui_NonBenefitHomeView__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                client: client,
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel
            })
        ]
    });
};
NonBenefitHomePages.Layout = _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NonBenefitHomePages);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,7509,9040,9653,1743,4365,5679,7787,1950,4429,5179,5203,4264,8152,3650,9774,2888,179], function() { return __webpack_exec__(45971); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);